<template>
  <div id="messagemainscontainer">        
    <ConversationContactList ></ConversationContactList>
    <ChatContainer></ChatContainer>        
  </div>
</template>


<script>
import ConversationContactList from './messagesItem/ConversationContactList.vue';
import ChatContainer from './messagesItem/Chat.vue';


export default {
  name: 'messagemainscontainer',
  components: {    
    ConversationContactList, 
    ChatContainer    
  }
};
</script>

<style>
#messagemainscontainer{
  height: calc(100vh - 55px);
  background-color: #fff;
}
#conversationcontactlist{    
    width: 260px;
    overflow-x: hidden;
    float: left;    
}
#messengercontainer, #chat{    
    height: 100%;
}

#chatcontainer{
  width: calc(100% - 260px);
  float: left;
}  

.aside-menu-lg-show #chatcontainer{
  width: calc(100% - 340px);
  float: left;
}  

#usercontainer{
  width: 340px;
  float: left;
}

@media all and  (max-width: 768px){
  #chatcontainer{
    width: calc(100% - 62px);
  }

  #conversationcontactlist{    
    width: 62px;
  }  
}

</style>